/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getFollows.defs.js'
export { main as default } from './getFollows.defs.js'
